import {
    FaStar,
   
    FaPlus,
  } from "react-icons/fa";
  import React, { useEffect, useMemo, useRef, useState } from "react";
  import { Link } from "react-router-dom";
  import { apiClient } from "../../api";
  import { baseUrl } from "../../Environments/environment";
  import { useProperty } from "../../Contexts/PropertyContext/PropertyContext";
  import { toast } from "react-toastify";
  import MilestoneModal from "./MilestoneModal";
  import MilestoneCard from "./MilestoneCard";
  import MilestoneSkeleton from "./MilestoneSkeleton";
  
  export function calculateRequiredReviews(R0, N0, T) {
    if (T >= 5) return 0;
    return Math.ceil(((T - R0) * N0) / (5 - T));
  }
  
  export function calculateEstimatedRequests(
    requiredReviews,
    conversionRate = 0.2
  ) {
    return Math.ceil(requiredReviews / conversionRate);
  }
  
  const CONVERSION_RATE = 0.2;
  
  export function calculateRequiredFiveStar(
    currentRating,
    currentReviewCount,
    targetRating
  ) {
    if (targetRating <= currentRating || targetRating >= 5) return 0;
  
    return Math.ceil(
      ((targetRating - currentRating) * currentReviewCount) / (5 - targetRating)
    );
  }
  
  export function calculateLinksToSend(requiredFiveStar) {
    return Math.ceil(requiredFiveStar / CONVERSION_RATE);
  }
  
  function enrichUpcomingMilestone(
    targetRating,
    currentRating,
    currentReviewCount
  ) {
    const requiredFiveStar = calculateRequiredFiveStar(
      currentRating,
      currentReviewCount,
      targetRating
    );
  
    const linksToSend = calculateLinksToSend(requiredFiveStar);
  
    return {
      requiredFiveStar,
      linksToSend,
      action: `Send ${linksToSend} review links`,
    };
  }
  
  export default function MileStone() {
    const { selectedPropertyId } = useProperty();
  
    const [isLoading, setIsLoading] = useState(false);
    // fetchDone = true once all initial fetches have returned (success OR error)
    const [fetchDone, setFetchDone] = useState(false);
  
    const [currentRating, setCurrentRating] = useState(-1);
    const [currentReviewCount, setCurrentReviewCount] = useState(-1);
    const [intialRating, setInitialRating] = useState(3.7);
    const [initialReviewCount, setInitialReviewCount] = useState(80);
    const [milestones, setMilestones] = useState([]);
    const [mergedStartCurrent, setMergedStartCurrent] = useState(null);
    const [isMilestoneModalOpen, setIsMilestoneModalOpen] = useState(false);
    const [placeId, setPlaceId] = useState("");
    const hasAutoCreatedRef = useRef(false);
  
   
    useEffect(() => {
      hasAutoCreatedRef.current = false;
      if (selectedPropertyId) {
        setPlaceId("");
        setCurrentRating(-1);
        setCurrentReviewCount(-1);
        setMilestones([]);
        setMergedStartCurrent(null);
        getPlaceId();
      }
    }, [selectedPropertyId]);
  
    useEffect(() => {
      if (placeId) {
        console.log("placeId", placeId);
        getReviewsMetrics();
      }
    }, [placeId]);
  
    useEffect(() => {
      if (currentRating > -1 && currentReviewCount > -1) {
        getMileStones().finally(() => setFetchDone(true));
      }
    }, [currentRating, currentReviewCount]);
  
    const handleMilestoneSubmit = async (milestoneData) => {
      try {
        setIsLoading(true);
        const token = localStorage.getItem("accessToken");
  
        const res = await apiClient.post(
          `${baseUrl}/reviewMilestone/${selectedPropertyId}`,
          milestoneData,
          { headers: { Authorization: `Bearer ${token}` } }
        );
  
        if (res.data.statusCode !== 201) return;
  
        getMileStones();
      } catch (error) {
        console.error("Error fetching milestones", error);
      } finally {
        setIsLoading(false);
      }
    };
  
    const handleOpenMilestoneModal = () => {
      // Check if there's an ongoing (upcoming) milestone
      const hasOngoingMilestone = milestones.some((m) => m.status === "Upcoming");
  
      if (hasOngoingMilestone) {
        toast.warning(
          "Your current milestone is in progress, you can set new milestone after achieved this milestone."
        );
        return;
      }
  
      setIsMilestoneModalOpen(true);
    };
  
    const getPlaceId = async () => {
      try {
        setIsLoading(true);
        const token = localStorage.getItem("accessToken");
        const reviewsJobsResponse = await apiClient.get(
          `${baseUrl}/reviews/jobs/${selectedPropertyId}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        if (reviewsJobsResponse.data.statusCode === 200) {
          console.log(
            "reviewsJobsResponse.data.result1",
            reviewsJobsResponse.data.result
          );
          const data = reviewsJobsResponse.data.result.reviewJobs;
          const googleItem = data.find((item) => item.network === "google");
          const googleSlug = googleItem?.slug || null;
          setPlaceId(googleSlug);
          // If no Google account is linked, mark fetch as done so skeleton resolves
          if (!googleSlug) {
            setFetchDone(true);
          }
        } else {
          // API responded but no success – mark done to exit skeleton
          setFetchDone(true);
        }
      } catch (error) {
        console.error("Error fetching reviews metrics:", error);
        // On error, still exit skeleton
        setFetchDone(true);
      } finally {
        setIsLoading(false);
      }
    };
    const createStartMilestone = async () => {
      const token = localStorage.getItem("accessToken");
  
      return apiClient.post(
        `${baseUrl}/reviewMilestone/${selectedPropertyId}`,
        {
          milestoneRecord: currentRating,
          status: "Start",
          network: "google",
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
    };
  
    const getMileStones = async () => {
      try {
        setIsLoading(true);
        const token = localStorage.getItem("accessToken");
  
        const res = await apiClient.get(
          `${baseUrl}/reviewMilestone/${selectedPropertyId}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
  
        if (res.data.statusCode !== 200) return;
  
        const records = res.data.result.milestoneRecords;
  
        if (
          records.length === 0 &&
          currentRating > 0 &&
          !hasAutoCreatedRef.current
        ) {
          hasAutoCreatedRef.current = true;
          await createStartMilestone();
          return getMileStones();
        }
  
        // ================= NORMAL FLOW =================
  
        const start = records.find((r) => r.status === "Start");
        const achieved = records.filter((r) => r.status === "Achieved");
        const upcomingDB = records.filter((r) => r.status === "Upcoming");
  
        const baseRating = start?.milestoneRecord ?? currentRating;
        setInitialRating(baseRating);
  
        // Create merged Start/Current card
        const mergedCard = {
          startRating: baseRating,
          currentRating: currentRating,
          increase: (currentRating - baseRating).toFixed(1),
          status: currentRating > baseRating ? "Current" : "Start",
        };
        setMergedStartCurrent(mergedCard);
  
        // Organize milestones: Achieved first, then Upcoming
        const uiMilestones = [];
  
        achieved.forEach((r) => {
          uiMilestones.push({
            rating: r.milestoneRecord,
            increase: (r.milestoneRecord - baseRating).toFixed(1),
            action: "Milestone Achieved",
            status: "Achieved",
          });
        });
  
        upcomingDB.forEach((r) => {
          const calc = enrichUpcomingMilestone(
            r.milestoneRecord,
            currentRating,
            currentReviewCount
          );
  
          uiMilestones.push({
            rating: r.milestoneRecord,
            increase: (r.milestoneRecord - baseRating).toFixed(1),
            status: "Upcoming",
            ...calc,
          });
        });
  
        setMilestones(uiMilestones);
      } catch (error) {
        console.error("Error fetching milestones", error);
      } finally {
        setIsLoading(false);
      }
    };
  
    const getReviewsMetrics = async () => {
      try {
        setIsLoading(true);
        const token = localStorage.getItem("accessToken");
        const reviewsMetricsResponse = await apiClient.get(
          `${baseUrl}/property/details?place_id=${placeId}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        if (reviewsMetricsResponse.data.statusCode === 200) {
          console.log(
            "Review Count :- ",
            reviewsMetricsResponse.data.result.user_ratings_total
          );
          setCurrentRating(reviewsMetricsResponse.data.result.rating);
          setCurrentReviewCount(
            reviewsMetricsResponse.data.result.user_ratings_total
          );
        } else {
          setFetchDone(true);
        }
      } catch (error) {
        console.error("Error fetching reviews metrics:", error);
        setFetchDone(true);
      } finally {
        setIsLoading(false);
      }
    };
  
    // Component is ready when either Google data arrived OR fetches completed (even without Google)
    const isDataReady = (currentRating > -1 && currentReviewCount > -1) || fetchDone;
  
    if (isLoading) {
      return <MilestoneSkeleton />;
    }

    if (!isDataReady) {
      return (
        <div className="bg-white p-5 rounded-xl shadow mb-6">
          <div className="flex justify-between items-center mb-4">
            <h3 className="font-medium text-lg flex items-center gap-2">
              <FaStar className="text-yellow-500" /> Rating Progress & Milestones
            </h3>
          </div>
          <div className="flex flex-col items-center justify-center min-h-[160px] sm:min-h-[220px] py-4 sm:py-8 px-4 text-center border-2 border-dashed border-gray-200 rounded-xl bg-gray-50/30">
            <div className="h-8 w-8 sm:h-10 sm:w-10 rounded-full bg-yellow-50 flex items-center justify-center mb-2 sm:mb-3">
              <FaStar className="text-sm sm:text-xl text-yellow-500" />
            </div>
            <h4 className="text-xs sm:text-sm font-semibold text-gray-800">
              {!placeId ? "Google Review URL Not Found" : "Unable to Load Google Rating"}
            </h4>
            <p className="text-[10px] sm:text-xs text-gray-500 max-w-xs sm:max-w-md mt-1 leading-relaxed line-clamp-2">
              {!placeId 
                ? "Please connect your Google Business account in property settings to start tracking your rating milestones."
                : "We couldn't fetch rating details from Google. Please verify your Google review setup or check connection."}
            </p>
            <Link
              to="/dashboard/configure/platform-integration"
              className="mt-3 sm:mt-4 bg-indigo-600 hover:bg-indigo-700 text-white font-medium py-1.5 sm:py-2 px-3 sm:px-4 rounded-md text-[11px] sm:text-sm transition-all"
            >
              Configure Integration
            </Link>
          </div>
        </div>
      );
    }

    return (
      <div className="bg-white p-5 rounded-xl shadow mb-6">
        <div className="flex justify-between items-center mb-6">
          <h3 className="font-medium text-lg flex items-center gap-2">
            <FaStar className="text-yellow-500" /> Rating Progress &
            Milestones
          </h3>
        </div>

        <div className="flex gap-4 items-start overflow-x-auto pb-2">
          {/* Merged Start/Current Card */}
          {mergedStartCurrent && (
            <div className="rounded-xl p-4 shadow border h-[180px] bg-white border-gray-300 flex-shrink-0 w-[180px]">
              <div className="flex flex-col h-full">
                <p className="text-xs text-gray-700 mb-2 font-medium">
                  Start with onelyk
                </p>
                <div className="flex-1 flex flex-col justify-center space-y-1">
                  <div className="flex justify-between items-center border-b border-gray-50 pb-1">
                    <span className="text-[10px] text-gray-400 font-medium">Start:</span>
                    <p className="text-base font-bold text-yellow-600 flex items-center gap-1">
                      ⭐ {mergedStartCurrent.startRating}
                    </p>
                  </div>
                  <div className="flex justify-between items-center pb-1">
                    <span className="text-[10px] text-gray-500 font-bold">Current:</span>
                    <p className="text-base font-bold text-yellow-600 flex items-center gap-1">
                      ⭐ {mergedStartCurrent.currentRating}
                    </p>
                  </div>
                  <p className={`text-[10px] font-bold pt-1 ${parseFloat(mergedStartCurrent.increase) < 0 ? "text-red-600" : "text-green-600"}`}>
                    {parseFloat(mergedStartCurrent.increase) < 0 ? "↘" : "↗ +"} {mergedStartCurrent.increase}
                  </p>
                </div>
                <div className="mt-auto pt-2">
                  <span className="text-[10px] px-2 py-1 rounded-full font-medium bg-blue-200 text-blue-800">
                    {mergedStartCurrent.status}
                  </span>
                </div>
              </div>
            </div>
          )}

          {/* Achieved and Upcoming Milestones */}
          {milestones.map((m, i) => (
            <div key={i} className="w-[180px] flex-shrink-0">
              <MilestoneCard data={m} />
            </div>
          ))}

          {/* Start New Milestone Card */}
          <div
            onClick={handleOpenMilestoneModal}
            className="rounded-xl p-4 shadow border-2 border-dashed border-gray-300 h-[180px] bg-white hover:bg-gray-50 cursor-pointer transition-colors flex flex-col items-center justify-center flex-shrink-0 w-[180px]"
          >
            <FaPlus className="text-3xl text-gray-400 mb-2" />
            <p className="text-xs text-gray-600 font-medium text-center">
              Start new milestone
            </p>
          </div>
        </div>

        <MilestoneModal
          isOpen={isMilestoneModalOpen}
          currentRating={currentRating}
          onClose={() => setIsMilestoneModalOpen(false)}
          onSubmit={handleMilestoneSubmit}
        />
      </div>
    );
  }
  